<script setup lang="ts">
    import { computed, toRef } from 'vue'
    import type { ProjectClonerViewModel } from '@Projects/Components/ProjectCloner'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        viewModel: ProjectClonerViewModel
    }>()

    const emit = defineEmits<{
        (e: 'clone-project', sourceId: number | string | null, name: string | null): void
    }>()

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const cloning = computed(() => vm.value.cloning)
    const nameError = computed(() => vm.value.nameError)

    const name = computed<string | null>({
        get: () => vm.value.cloneName,
        set: val => { vm.value.cloneName = val }
    })

    // ---------------- methods ----------------

    function handleFormSubmit()
    {
        vm.value.cloning = true
        emit('clone-project', vm.value.sourceId, name.value)
    }

    function close()
    {
        vm.value.close()
    }
</script>


<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Clone</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="project-cloner-form" @submit.prevent="handleFormSubmit">
                            <div class="form-group">
                                <label>Clone Name (2-100 characters):</label>
                                <input v-model.trim="name" type="text" class="form-control" required minlength="2" maxlength="100" />
                                <div v-if="nameError" class="error">{{nameError}}</div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer text-right">
                        <button type="button" @click="close" :disabled="cloning" class="btn btn-secondary">Close</button>
                        <button type="submit" form="project-cloner-form" :disabled="cloning" class="btn btn-primary">
                            {{cloning ? 'Cloning...' : 'Clone'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>